import 'isomorphic-fetch'

const sendContactMail = mailObject => new Promise((resolve, reject) => {
    fetch('/api/v1/contact-mail', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            name: mailObject.name,
            company: mailObject.company,
            email: mailObject.email,
            phone: mailObject.phone,
            category: mailObject.category,
            subCategory: mailObject.subCategory,
            message: mailObject.message
        })
    })
        .then(data => data.json())
        .then((data) => {
            if (!data.error) {
                resolve(data)
            } else {
                reject()
            }
        })
        .catch(() => {
            reject()
        })
})
export default sendContactMail



// WEBPACK FOOTER //
// ./src/scripts/api/sendContactMail.js